import { MatTable } from '@angular/material';
import { ExcelTableConfig } from '@iad-digital/iad-ngx-core';
import { createAction, props } from '@ngrx/store';

export const exportTable = createAction(
  '[SHARED] EXPORT_TABLE',
  props<{ title: string; table: MatTable<unknown>; config?: ExcelTableConfig }>()
);
